import { create } from "zustand";
import { merchantApi, type MerchantShopItem } from "../api/client";

type MerchantShopsState = {
  shops: MerchantShopItem[];
  isLoading: boolean;
  error: Error | null;
  fetchShops: () => Promise<void>;
  clearShops: () => void;
  getShop: (shopId: string) => MerchantShopItem | undefined;
  getPermissions: (shopId: string) => string[];
};

export const useMerchantShopsStore = create<MerchantShopsState>((set, get) => ({
  shops: [],
  isLoading: false,
  error: null,

  fetchShops: async () => {
    set({ isLoading: true, error: null });
    try {
      const { items } = await merchantApi.getShops();
      set({ shops: items, isLoading: false });
    } catch (e) {
      set({
        error: e instanceof Error ? e : new Error(String(e)),
        shops: [],
        isLoading: false,
      });
    }
  },

  clearShops: () => set({ shops: [], error: null }),

  getShop: (shopId: string) => get().shops.find((s) => s.shopId === shopId),

  getPermissions: (shopId: string) => get().getShop(shopId)?.permissions ?? [],
}));
